import { getGlobalHandle } from '@getaccept/lib-shared/src/helpers';

export const useIntercomChat = () => {
  const openChat = () => {
    if (!getGlobalHandle().Intercom) {
      return;
    }
    getGlobalHandle().Intercom('show');
  };

  return {
    openChat,
  };
};
